import React from "react";

export default function Loader () {
  return (
    <div className="loader"><i className="fa-solid fa-spinner fa-spin-pulse"></i></div>
  );
}